interface JwtPayload {
  email: string;
  name: string;
  role: "user" | "admin";
  type: "access" | "refresh";
  iat: number;
  exp: number;
}

/**
 * JWTトークンをデコード（署名検証なし）
 * フロントエンドでのペイロード取得用
 */
export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      return null;
    }

    const payloadPart = parts[1];
    if (!payloadPart) {
      return null;
    }
    // Base64デコード後、UTF-8として正しく解釈する
    const base64 = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
    const binaryString = atob(base64);
    const bytes = Uint8Array.from(binaryString, (c) => c.charCodeAt(0));
    const decoded = new TextDecoder("utf-8").decode(bytes);
    return JSON.parse(decoded) as JwtPayload;
  } catch {
    return null;
  }
}
